<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconDtmf_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M13 20.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M13 14.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M13 8.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
    />
    <path fill="currentColor" d="M13 2.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0" />
    <path
        fill="currentColor"
        d="M19 14.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M19 8.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M19 2.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M7 14.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M7 8.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M7 2.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
    />
</svg>
